module.exports = __webpack_public_path__ + "static/media/cdkglobal_wm_blk.dbb367c6.svg";